import React from "react";
import './DMList.css'

const DMList = () => {
    
    return (
        <aside className='dm'>
            <div>
            <h1 className="dm-label">Direct Messages</h1>
            </div>
        </aside>
    )
}

export default DMList;